// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7KCUI","banner_text":"Banner_banner_text__ysrYd","scroll-right":"Banner_scroll-right__K9o6i"};